<template>
  <div class="user-card-wrapper">
    <div
      v-if="isMobile"
      class="group-share"
    >
      <el-button
        class="share"
        icon="icon-share"
        @click="openShareModal = true"
      />
      <favorite
        v-model="user.favoring_logged_in_user"
        :res="'users/favourite'"
        :entity-id="user.id"
        :entity-name="'favorite_user_id'"
      />
    </div>
    <el-card
      v-loading.fullscreen.lock="loading"
      class="user-card"
      shadow="always"
    >
      <el-row class="avatar-row">
        <el-col
          class="image-col"
          :sm="6"
        >
          <div class="user-image">
            <vue-load-image v-if="user.file">
              <img
                slot="image"
                :src="user.file.url_view | resizeImage(97, 97)"
                :data-src="user.file.url_view | resizeImage(97, 97)"
              >
              <div
                slot="preloader"
                v-loading="true"
                class="img-loading"
              >
                {{ $t('Loading ....') }}
              </div>
              <div slot="error">
                {{ $t('Network error') }}
              </div>
            </vue-load-image>
            <img
              v-else
              src="../assets/profile-default.png"
            >
          </div>
        </el-col>
        <el-col
          class="user-info"
          :sm="10"
        >
          <span class="name">{{ user.name }}</span>
          <span v-if="user.last_seen">{{ $t('user-profile.user-card.last-seen') }} {{ user.last_seen | diffForHumans(locale) }}</span>
        </el-col>
        <el-col
          class="right-buttons"
          :sm="8"
        >
          <div v-if="!isMobile && user">
            <el-button
              class="share"
              icon="icon-share"
              @click="openShareModal = true"
            />
            <favorite
              v-model="user.favoring_logged_in_user"
              :res="'users/favourite'"
              :entity-id="user.id"
              :entity-name="'favorite_user_id'"
            />
          </div>
          <el-button
            v-if="loggedUser && user.id !== loggedUser.id"
            class="massage red"
            icon="icon-massage"
            @click="writeMessageShow = !writeMessageShow"
          >
            {{ $t('user-profile.message') }}
          </el-button>
        </el-col>
      </el-row>
      <el-dialog
        class="categories"
        :title="$t('write-message.dialog.title')"
        :visible.sync="writeMessageShow"
        width="900px"
        center
      >
        <send-message
          :append-data="sendMessageData"
          :small-input="isMobile"
          @done="messageSent"
        >
          <template
            slot="beforeFields"
            slot-scope="{ form, error, change }"
          >
            <el-form-item
              :error="error('ad_id')"
              class="p-b-xs-30"
            >
              <select-primary-js
                resource="ads"
                :resource-options="{filter: userAdsFilters}"
                :placeholder="$t('write-message.ad_id.placeholder')"
                :value="{ id: form.ad_id, name: adSelectionName }"
                @input="form.ad_id = $event.id; adSelectionName = $event.name; change('ad_id')"
              >
                <template
                  slot="singleLabel"
                  slot-scope="{ option }"
                >
                  {{ option.name || $t('write-message.ad_id.placeholder') }}
                </template>
              </select-primary-js>
            </el-form-item>
          </template>
        </send-message>
      </el-dialog>
    </el-card>
    <el-dialog
      class="custom-message custom-addthis"
      :visible.sync="openShareModal"
      width="300px"
      center
    >
      <div
        :class="addThisClass"
        :data-url="shareUrl"
      />
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Favorite from '@/components/Core/Favorite';
import SendMessage from '@/components/Ads/SendMessage';
import SelectPrimaryJs from '@/components/MainLeftFilters/SelectPrimaryJs';
import get from 'lodash-es/get'
Vue.prototype.lazyLoadPackages.addThis.load();

export default {
  name: 'UserProfileCard',
  components: {
    Favorite,
    SendMessage,
    SelectPrimaryJs,
  },
  props: [
    // eslint-disable-next-line vue/require-prop-types
    'user',
  ],
  data() {
    return {
      loading: false,
      openShareModal: false,
      writeMessageShow: false,
      adSelectionName: '',
    };
  },
  computed: {
    ...mapState({
      addThisClass: state => state.config.addThisShareClass,
      isMobile: state => state.isMobile,
      loggedUser: state => state.auth.user,
      locale: state => state.locale,
      url: state => state.config ? state.config.apiUrl.replace('/api', '') : '',
    }),
    shareUrl() {
      const id = get(this.user, 'id')
      return `${this.url}/?profile_id=${id}#/profile/${id}`;
    },
    sendMessageData() {
      return this.loggedUser ? {
        user_id: this.loggedUser.id,
      } : null;
    },
    userAdsFilters() {
      return [{
        property: 'user_id',
        operator: '=',
        value: this.user.id,
      }, {
        property: 'active',
        operator: '=',
        value: true,
      }];
    },
  },
  watch: {
    openShareModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (typeof window.addthis !== 'undefined') {
            window.addthis.layers.refresh();
          }
        });
      }
    },
  },
  methods: {
    share() {
      if (navigator && navigator.share) {
        this.loading = true;
        navigator
          .share({ url: window.location.href })
          .then(() => { this.loading = false; })
          .catch(() => { this.loading = false; });
      }
    },
    messageSent() {
      this.writeMessageShow = false;
      this.$message({
        showClose: true,
        message: this.$t('message.success'),
        type: 'success',
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserProfileCard.vue